export default __webpack_public_path__ + "static/screen-mockup@2x-e1e78f252f3fb192991d3066a0cd20b8.jpg";